import { render } from "./ModalProdutos.vue?vue&type=template&id=0ecfce2a&scoped=true"
import script from "./ModalProdutos.vue?vue&type=script&lang=js"
export * from "./ModalProdutos.vue?vue&type=script&lang=js"

import "./ModalProdutos.vue?vue&type=style&index=0&id=0ecfce2a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ecfce2a"]])

export default __exports__